import axios from 'axios'

// Usa env se presente, altrimenti fallback al backend dev http
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL || 'http://10.45.14.100:3334/api',
  withCredentials: true,
});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      const status = error.response.status
      console.error('Errore nel server:', status)

      if (status === 403) {
        window.dispatchEvent(new Event('api:forbidden'))
      }

      if (status === 401) {
        // Token scaduto o invalido - logout automatico
        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')
        if (!window.location.pathname.startsWith('/login')) {
          window.location.href = '/login'
        }
      }

      // Gestione errori 500 che potrebbero essere problemi di sessione
      if (status === 500) {
        const errorMsg = error.response.data?.error || ''
        // Se il 500 sembra un problema di auth (user undefined, unauthorized, etc.)
        // oppure se non c'è più il token, redirect al login
        if (
          errorMsg.toLowerCase().includes('unauthorized') ||
          errorMsg.toLowerCase().includes('unauthenticated') ||
          !localStorage.getItem('accessToken')
        ) {
          localStorage.removeItem('accessToken')
          window.location.href = '/login'
        } else {
          // Dispatch evento per mostrare errore generico nell'UI
          window.dispatchEvent(new CustomEvent('api:error', {
            detail: { status, message: errorMsg || 'Errore del server' }
          }))
        }
      }
    } else if (error.request) {
      console.error('Errore di rete o problema di proxy:', error.request)
      // Nessuna risposta dal server - potrebbe essere offline
      window.dispatchEvent(new CustomEvent('api:error', {
        detail: { status: 0, message: 'Errore di connessione al server' }
      }))
    } else {
      console.error('Errore:', error.message)
    }
    return Promise.reject(error)
  }
)

export default api
